var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":"Telefoonnummer","error":_vm.error,"error-messages":_vm.message},on:{"blur":_vm.handleBlur},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})}
var staticRenderFns = []

export { render, staticRenderFns }